var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.Buchstabe,"hide-default-header":"","hide-default-footer":"","items-per-page":-1},scopedSlots:_vm._u([{key:"item.name",fn:function(ref){
var item = ref.item;
return [_c('b',[_vm._v(_vm._s(item.name))])]}},{key:"item.allergene",fn:function(ref){
var item = ref.item;
return [_c('b',[_vm._v(_vm._s(item.allergene))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }